import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { TrendingForYouLookRepositoryImpl } from "../../domain/trendingForYouLookRepositoryImpl/TrendingForYouLookRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const trendingForYouRepo = TrendingForYouLookRepositoryImpl.getInstance();

const useGetTrendingForYouLooks = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["useGetTrendingForYouLooks"],
      queryFn: async () => {
        return await trendingForYouRepo.get(auth, apiUrl);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return { looks: data, isLoading };
};

export { useGetTrendingForYouLooks };
